import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CognitoAuthProvider,
  OAuthCallbackHandler,
  storeTokens,
  decodeJwtPayload,
} from "@vault/cognito-auth";

import { setCredentials } from "./authSlice";
import cognitoConfig from "./cognitoConfig";

const Cognito = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSuccess = useCallback(
    (tokens) => {
      storeTokens(tokens);
      const decoded = decodeJwtPayload(tokens.idToken);
      dispatch(
        setCredentials({
          token: tokens.idToken,
          uid: decoded.sub,
          roles: decoded.rls ? decoded.rls.split("|") : [],
        })
      );
      navigate("/", { replace: true });
    },
    [dispatch, navigate]
  );

  const handleError = useCallback(
    (error) => {
      console.error("OAuth callback error:", error);
      const params = new URLSearchParams(window.location.search);
      const errorDesc = params.get("error_description") || "";
      const isNotInvited = errorDesc.includes("PreSignUp");
      navigate("/login", {
        replace: true,
        state: isNotInvited ? { error: "not_invited" } : { error: "auth_error" },
      });
    },
    [navigate]
  );

  return (
    <CognitoAuthProvider config={cognitoConfig}>
      <OAuthCallbackHandler onSuccess={handleSuccess} onError={handleError} />
    </CognitoAuthProvider>
  );
};

export default Cognito;
